module.exports = __webpack_public_path__ + "img/icon-google-play.a3090bc5.png";